import Vue from 'vue'

const getDocumentMedia = () => {
  const mediaQuerySm = window.matchMedia('(max-width: 749px)')
  const mediaQueryMd = window.matchMedia('(min-width: 750px)')
  const mediaQueryLg = window.matchMedia('(min-width: 1060px)')
  const mediaQueryXl = window.matchMedia('(min-width: 1440px)')

  if (mediaQuerySm.matches) {
    Vue.prototype.$media = 'sm'
  }

  if (mediaQueryMd.matches) {
    Vue.prototype.$media = 'md'
  }

  if (mediaQueryLg.matches) {
    Vue.prototype.$media = 'lg'
  }

  if (mediaQueryXl.matches) {
    Vue.prototype.$media = 'xl'
  }
}

window.addEventListener('resize', getDocumentMedia)
getDocumentMedia()
